// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"378":"0eea971b","538":"bfbae43d"}[chunkId] + ".chunk.css";
};